import { Field, ProjectLocationMap, Select, TextArea, TextInput } from './WizardControls';

export default function ProjectInfoStep({
  platformProjects,
  projectForm,
  selectedProject,
  selectedProjectId,
  canCreateProject,
  onProjectSelect,
  onProjectFormChange,
  onSave
}) {
  const update = (patch) => onProjectFormChange({ ...projectForm, ...patch });

  return (
    <div className="dev-project-info-layout">
      <div className="dev-panel dev-project-location-panel">
        <h2>موقعیت پروژه</h2>
        <ProjectLocationMap
          latitude={projectForm.latitude}
          longitude={projectForm.longitude}
          onChange={(point) => update(point)}
        />
        {selectedProject && <small className="dev-muted">پروژه انتخاب شده: {selectedProject.name}</small>}
      </div>

      <form className="dev-panel dev-project-form-panel" onSubmit={onSave}>
        <div className="dev-panel-head">
          <div>
            <h2>ثبت پروژه پیش فروش</h2>
            <p>پروژه ساخته یا به روز می شود و مراحل بعد روی همین پروژه ذخیره می شوند.</p>
          </div>
        </div>
        <div className="dev-form-grid">
          <Field label="پروژه فعال">
            <Select value={selectedProjectId} onChange={onProjectSelect}>
              <option value="" disabled={!canCreateProject}>پروژه جدید</option>
              {platformProjects.map((project) => <option key={project.id} value={project.id}>{project.name}</option>)}
            </Select>
          </Field>
          <Field label="نام پروژه"><TextInput value={projectForm.name} onChange={(value) => update({ name: value })} required /></Field>
          <Field label="آدرس"><TextInput value={projectForm.address} onChange={(value) => update({ address: value })} /></Field>
          <Field label="شروع ساخت"><TextInput type="date" value={projectForm.construction_started_at} onChange={(value) => update({ construction_started_at: value })} /></Field>
          <Field label="تحویل مورد انتظار"><TextInput type="date" value={projectForm.expected_completion_at} onChange={(value) => update({ expected_completion_at: value })} /></Field>
          <Field label="تعداد کل واحد"><TextInput type="number" value={projectForm.total_units} onChange={(value) => update({ total_units: value })} /></Field>
          <Field label="توضیحات"><TextArea value={projectForm.description} onChange={(value) => update({ description: value })} /></Field>
        </div>
      </form>
    </div>
  );
}
